// extracted by mini-css-extract-plugin
module.exports = {"langs":"styles-module--langs--fzByE","is_active":"styles-module--is_active--2muts"};